<template>
    <Link
        class="btn btn-warning"
        method="post"
        :data="{uuid: customerUuid}"
        href="/scan/devolution"
    >{{ $t('button.devolution') }}</Link>
</template>

<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
const { customerUuid } = defineProps<{
    customerUuid: string
}>()
</script>

<style scoped>

</style>
